var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative cursor-pointer",class:{'!text-orange-700': _vm.recording_stream},on:{"click":_vm.toggleRecord}},[_c('i',{staticClass:"relative fas fa-microphone"}),_vm._v(" "),_c('span',{staticClass:"absolute inline-flex bg-orange-400 rounded-full opacity-75 animate-ping h-9 w-9",class:{'hidden': !_vm.recording_stream}})])
}
var staticRenderFns = []

export { render, staticRenderFns }